__turbopack_context__.v({
  "form": "select-cta-module-scss-module__Gi-0Za__form",
  "placeholder": "select-cta-module-scss-module__Gi-0Za__placeholder",
  "select-cta": "select-cta-module-scss-module__Gi-0Za__select-cta",
  "select-cta-container": "select-cta-module-scss-module__Gi-0Za__select-cta-container",
  "select-cta-container-inline": "select-cta-module-scss-module__Gi-0Za__select-cta-container-inline",
});
